const IDB_DATABASE = `oshikem_${process.env.REACT_APP_ENVIRONMENT}_20260809`;

export function pluralize(name, count) {
  if (count === 1) {
    return name;
  }
  return name + 's';
}

export function idbPromise(storeName, method, object) {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open(IDB_DATABASE, process.env.REACT_APP_IDB_VERSION);
    let db, tx, store;
    // *********************************************************
    // IMPORTANT: If this schema changes in an incompatible way,
    //            update REACT_APP_IDB_VERSION in .env (local) 
    //            and buildspec.yml (public/deployed)
    request.onupgradeneeded = function(e) {
      const db = request.result;
      db.createObjectStore('cart', { keyPath: '_id' });
    };

    request.onerror = reject;

    request.onsuccess = function(e) {
      db = request.result;
      tx = db.transaction(storeName, 'readwrite');
      store = tx.objectStore(storeName);

      db.onerror = function(e) {
        console.log('error', e);
      };

      switch (method) {
        case 'put':
          store.put(object);
          resolve(object);
          break;
        case 'get':
          const all = store.getAll();
          all.onsuccess = function() {
            resolve(all.result);
          };
          break;
        case 'delete':
          store.delete(object._id);
          break;
        default:
          console.log('No valid method');
          break;
      }

      tx.oncomplete = function() {
        db.close();
      };
    };
  });
}
